import { isDataLayerAvailable } from '@/tag-manager';
import { CUSTOM_EVENT_DYNAMIC_EVENT } from '@/tag-manager/constants';

export const EVENT_NAME = 'dealer';
interface TrackDealerParams {
  action?: 'impression' | string;
  group: string;
  value?: string;
}

export const DEALER_EVENTS = {
  NAME: 'dealer',
  CLICK: 'dealer_click',
};

export const trackDealer = ({
  group,
  action = 'impression',
  value = 'view',
}: TrackDealerParams) => {
  if (!isDataLayerAvailable()) return;

  window.dataLayer.push({
    event: CUSTOM_EVENT_DYNAMIC_EVENT,
    event_name: DEALER_EVENTS.NAME,
    group,
    action,
    value,
  });
};
